require('./featuredImageController');

"use strict";

angular.module('app.shared.featuredImage.featuredImageDirective', [
    'app.shared.featuredImage.featuredImageController'
])
.directive('featuredImage', [
    function () {
        return {
            restrict: 'E',
            templateUrl: 'components/shared/featuredImage/featuredImageView.html',
            controller: 'app.shared.featuredImage.featuredImageController',
            scope: {
            }
        }
    }
]);


// WEBPACK FOOTER //
// ./app.v2/components/shared/featuredImage/featuredImageDirective.js